// extracted by mini-css-extract-plugin
export var contentContainer = "RichTextModule-module--contentContainer--47b95";
export var text = "RichTextModule-module--text--e30d2";